import ApiHandler from './ApiHandler';

export default {
    getAllSeasons: id => ApiHandler.post(`/auth/login?id=${id}`, data)
};
